import $ from "jquery";

// https://www.codeply.com/go/EIOtI7nkP8

$("#pageCarousel-1").carousel({
  interval: 40000,
});

$("#pageCarousel-2").carousel({
  interval: 40000,
});

$("#pageCarousel-3").carousel({
  interval: 40000,
});

$(".carousel .carousel-item").each(function () {
  var minPerSlide = 3;
  var next = $(this).next();
  if (!next.length) {
    next = $(this).siblings(":first");
  }
  next.children(":first-child").clone().appendTo($(this));

  for (var i = 0; i < minPerSlide; i++) {
    next = next.next();
    if (!next.length) {
      next = $(this).siblings(":first");
    }

    next.children(":first-child").clone().appendTo($(this));
  }
});
